import { useState, useMemo } from "react";
import {
  Container,
  Paper,
  CircularProgress,
  Alert,
  Box,
  Typography,
  Button,
  Modal,
  TextField,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Autocomplete,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Divider
} from "@mui/material";
import { modalStyle, buttonGuardar, buttonCancelar, Titulo, TituloPrincipal, Input, TituloColor, Texto, InputBuscador } from "../../Layouts/CustomStyles";
import { DataGrid } from "@mui/x-data-grid";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import { useGetDeudores } from "../../Hook/CBO/Deudores";
import { DiseñoDataGrid } from "../../Components/FuncionesGenerales/DataGrid";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useDeudoresCBO } from "../../Services/Deudores";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import Logocolor from "../../Image/Logo.png";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { FaTrashCan } from "react-icons/fa6";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { BsExclamationTriangle, BsHourglassSplit, BsCashStack } from "react-icons/bs";
import { BsClockHistory } from "react-icons/bs";
import { FaUserEdit } from "react-icons/fa";
import { useGetDeudoresReporteFinancieroActual } from "../../Hook/CBO/Deudores";
import { Loading } from "../../Utils/Loading";
import { formatCLP } from "../../Components/FuncionesGenerales/FormatoCLP";
import { useGetDeudoresAnteriores } from "../../Hook/CBO/Deudores";
import { useGetReporteAnual } from "../../Hook/CBO/Deudores";

import {
  BsFileEarmarkRuledFill,
  BsFileEarmarkExcelFill
} from "react-icons/bs";



export const PaginaCobroyDevengo = () => {
  const {
  reporteAnual,
  anualSeleccionado,
  cambiarAnio,
  loadingReporteAnual,
} = useGetReporteAnual();

  const { 
    deudores, 
    loadingDeudores, 
    errorDeudores, 
    refetchDeudores: fetchGetDeudores
   } = useGetDeudores();
  const {
    deudoresReporte,
    errorDeudoresReporte,
    loadingDeudoresReporte
  } = useGetDeudoresReporteFinancieroActual();
const [mesConsulta, setMesConsulta] = useState(null);
const [anioConsulta, setAnioConsulta] = useState(null);
 const {
  deudoresReporteanterior,
} = useGetDeudoresAnteriores(mesConsulta, anioConsulta);


  const { RegistrarPagoDeudor, eliminarPagoDeudor, editarPacienteDeudor,  descargarExcelDeudores } = useDeudoresCBO();
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpenEdit, setDialogOpenEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [montoPagado, setMontoPagado] = useState("");
  const [fechaPago, setFechaPago] = useState("");
  const [sesionesPagadas, setSesionesPagadas] = useState("");
  const [episodios, setEpisodios] = useState("");
  const [abonoDialogOpen, setAbonoDialogOpen] = useState(false);
  const [egresoSeleccionado, setEgresoSeleccionado] = useState(null);
  const [openEliminar, setOpenEliminar] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const [estadoFiltro, setEstadoFiltro] = useState("");
  const [NuevoMonto, setNuevoMonto] = useState("");
  const [NuevasSesiones, setNuevasSesiones] = useState("");
  const [dialogMeses, setDialogMeses] = useState(false);
  const [mesSeleccionado, setMesSeleccionado] = useState("");
  const [anioSeleccionado, setAnioSeleccionado] = useState("");
  const [mesFiltro, setMesFiltro] = useState("");
  const [anioFiltro, setAnioFiltro] = useState("");
  const [sucursalFiltro, setSucursalFiltro] = useState("");

  const handleDescargarExcel = async () => {
  try {
    setEnviandoAlert(true);

    await descargarExcelDeudores();

    setAlertMessage("Excel descargado correctamente ✅");
    setSuccessAlertOpen(true);

  } catch (error) {
    setAlertMessage(error?.message || "Error al exportar Excel");
    setErrorAlertOpen(true);
  } finally {
    setEnviandoAlert(false);
  }
};


  const filas = deudores
  .filter(item => item.estado !== "PAGADO")
  .map((item) => {
    const totalSesionesPagadas = item.pagos?.reduce(
      (acc, pago) => acc + Number(pago.sesiones_pagadas || 0),
      0
    );

    return {
      id: item.id,
      nombre_paciente: item.ingreso_paciente?.nombre_paciente || "—",
      rut: item.ingreso_paciente?.rut || "—",
      prevision: item.ingreso_paciente?.prevision || "—",
      fecha_pago: item.ingreso_paciente?.fecha_pago || "—",
      n_sesiones: item.ingreso_paciente?.n_sesiones || "-",
      monto: item.ingreso_paciente?.monto || 0,
      saldo_restante: item.saldo_restante,
      total_deuda: item.total_deuda,
      estado_pago: item.estado,
      pagos: item.pagos || [],
      total_sesiones_pagadas: totalSesionesPagadas,

      sucursal: item.ingreso_paciente?.branch?.name || "Sin sucursal",
    };
  });





  const columns = [
    {
      field: "nombre_paciente",
      headerName: "Nombre",
      flex: 2,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{ textTransform: 'capitalize', fontFamily: 'Poppins' }}
          >
            {params.row.nombre_paciente}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13, fontFamily: 'Poppins' }}>
            {params.row.rut || "-"}
          </Typography>
           <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13, fontFamily: 'Poppins' }}>
            {params.row.sucursal || "-"}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: 'italic', fontSize: 13, fontFamily: 'Poppins' }}
          >
            {params.row.prevision || "-"}
          </Typography>
        </Box>
      ),
    },

    {
      field: "estado_pago",
      headerName: "Estado",
      flex: 1,
      renderCell: (params) => {
        const estado = params.row.estado_pago?.toUpperCase(); // "DEUDA", "PROCESO", "PAGADO"
        const saldo = params.row.saldo_restante;
        const total = params.row.total_deuda;

        let backgroundColor, color, label, icon;

        switch (estado) {
          case "DEUDA":
            backgroundColor = "#FDECEA";
            color = "#C62828";
            label = "Deuda";
            icon = <WarningAmberIcon sx={{ fontSize: 20, animation: "blink 1s infinite" }} />;
            break;

          case "PROCESO":
            backgroundColor = "#FFF8E1";
            color = "#F9A825";
            label = "En proceso";
            icon = <HourglassBottomIcon sx={{ fontSize: 20 }} />;
            break;

          case "PAGADO":
            backgroundColor = "#E8F5E9";
            color = "#2E7D32";
            label = "Pagado";
            icon = <CheckCircleIcon sx={{ fontSize: 20 }} />;
            break;

          default:
            // Si no viene estado del backend, deduce por saldo
            if (saldo === 0) {
              backgroundColor = "#E8F5E9";
              color = "#2E7D32";
              label = "Pagado";
              icon = <CheckCircleIcon sx={{ fontSize: 20 }} />;
            } else if (saldo !== total) {
              backgroundColor = "#FFF8E1";
              color = "#F9A825";
              label = "En proceso";
              icon = <HourglassBottomIcon sx={{ fontSize: 20 }} />;
            } else {
              backgroundColor = "#FDECEA";
              color = "#C62828";
              label = "Deuda";
              icon = <WarningAmberIcon sx={{ fontSize: 20, animation: "blink 1s infinite" }} />;
            }
            break;
        }

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              backgroundColor,
              color,
              fontWeight: 600,
              fontSize: 14,
              textAlign: "center",
              width: "100%",
              height: '80px',
              fontFamily: "Poppins",
            }}
          >
            {icon}
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
              {label}
            </Typography>
          </Box>
        );
      },
    },

    {
      field: "fecha_pago",
      headerName: "Fecha de Ingreso",
      flex: 1,

    },
    {
      field: "n_sesiones",
      headerName: "Sesiones contratada",
      flex: 1,
    },
    {
      field: "total_sesiones_pagadas",
      headerName: 'Sesiones Pagadas',
      flex: 1
    },
    {
      field: "saldo_restante",
      headerName: "Saldo Restante",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("es-CL", {
          style: "currency",
          currency: "CLP",
          minimumFractionDigits: 0,
        }).format(params.row.saldo_restante || 0),
    },
    {
      field: "total_deuda",
      headerName: "Total Deuda",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("es-CL", {
          style: "currency",
          currency: "CLP",
          minimumFractionDigits: 0,
        }).format(params.row.total_deuda || 0),
    },
    {
      field: "acciones",
      headerName: "Acciones",
      flex: 1,
      renderCell: (params) => {


        return (
          <Box sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            flexDirection: 'column'
          }}>
            <Button
              variant="contained"
              size="small"
              sx={{
                mt: 1,
                fontFamily: "Poppins",
                backgroundColor: "#d49330ff",
                textTransform: "capitalize",
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-around    ',
                width: '120px',
                "&:hover": { backgroundColor: "#d47a30ff" },
              }}
              onClick={() => handleOpenDialogEdit(params.row)}
            >
              <FaUserEdit size={16} style={{ padding: 1 }} />
              Editar Pago
            </Button>
            <Button
              variant="contained"
              size="small"
              sx={{
                mt: 1,
                fontFamily: "Poppins",
                backgroundColor: "#4CAF50",
                textTransform: "capitalize",
                "&:hover": { backgroundColor: "#3e8e41" },
              }}
              onClick={() => handleOpenDialog(params.row)}
            >
              Registrar Pago
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => handleOpenAbonoDialog(params.row)}
              sx={{
                mt: 1,
                mb: 1,
                fontFamily: "Poppins",
                backgroundColor: "#4c96afff",
                textTransform: "capitalize",
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-around    ',
                width: '120px',
                "&:hover": { backgroundColor: "#4c96afff" },
              }}

            >
              <BsClockHistory size={16} sx={{ p: 1 }} />
              Historial
            </Button>
          </Box>
        );
      },
    }

    ,

  ];


  const filasFiltradas = useMemo(() => {
  // 1️⃣ Ordenar por fecha (descendente)
  const filasOrdenadas = [...filas].sort((a, b) => {
    const fechaA = new Date(a.fecha_pago);
    const fechaB = new Date(b.fecha_pago);
    return fechaB - fechaA;
  });

  // 2️⃣ Filtrar
  return filasOrdenadas.filter((row) => {
    const nombre = row.nombre_paciente?.toLowerCase() || "";
    const rutLimpio = row.rut?.replace(/\./g, "").toLowerCase() || "";
    const textoBusqueda = busqueda?.toLowerCase().trim() || "";

    // 📅 Año y mes
    const fecha = row.fecha_pago;
    const [anio, mes] = fecha ? fecha.split("-") : ["", ""];

    // ✔️ Filtros
    const coincideMes = mesFiltro ? mes === mesFiltro : true;
    const coincideAño = anioFiltro ? anio === anioFiltro : true;

    const coincideBusqueda =
      nombre.includes(textoBusqueda) ||
      rutLimpio.includes(textoBusqueda);

    const coincideEstado = estadoFiltro
      ? row.estado_pago?.toUpperCase() === estadoFiltro.toUpperCase()
      : true;

    const coincideSucursal = sucursalFiltro
      ? row.sucursal === sucursalFiltro
      : true;

    // 🔥 Filtro final
    return (
      coincideBusqueda &&
      coincideEstado &&
      coincideMes &&
      coincideAño &&
      coincideSucursal
    );
  });
}, [
  filas,
  busqueda,
  estadoFiltro,
  mesFiltro,
  anioFiltro,
  sucursalFiltro
]);



  
  const opcionesUnicas = useMemo(() => {
    const vistos = new Set();
    return filas.filter((f) => {
      const rutLimpio = f.rut?.replace(/\./g, "").toLowerCase();
      if (vistos.has(rutLimpio)) return false;
      vistos.add(rutLimpio);
      return true;
    });
  }, [filas]);



  const handleOpenAbonoDialog = (row) => {

    setSelectedRow(row);
    setAbonoDialogOpen(true);
  };


  const handleCloseAbonoDialog = () => {
    setAbonoDialogOpen(false);
  };

  // Aquí definimos las columnas del historial de abonos
  const abonoColumns = [
    {
      field: "fecha_pago",
      headerName: "Fecha de Pago",
      width: 180,
    },
    {
      field: "monto_pagado",
      headerName: "Monto Pagado",
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("es-CL", {
          style: "currency",
          currency: "CLP",
          minimumFractionDigits: 0,
        }).format(params.row.monto_pagado),
    },
    {
      field: "episodios",
      headerName: "Episodios",
      width: 180,
    },
    {
      field: "sesiones_pagadas",
      headerName: "Sesiones Pagadas",
      width: 180,
      renderCell: (params) => params.row.sesiones_pagadas || "-",
    },
    {
      field: "acciones",
      headerName: "Acciones",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            width: 150,
            alignItems: "center",
            justifyContent: "center",
          }}
        >

          <button
            className="delete-button"
            onClick={() => handleOpenEliminar(params.row)}
          >
            <FaTrashCan className="delete-svgIcon" />
          </button>
        </Box>
      ),
    }
  ];

  // Datos de ejemplo desde la relación pagos del deudor
  const abonosRows = selectedRow?.pagos?.map((pago) => ({
    id: pago.id,
    fecha_pago: pago.fecha_pago,
    monto_pagado: pago.monto_pagado,
    sesiones_pagadas: pago.sesiones_pagadas,
    episodios: pago.episodios,
  })) || [];




  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setDialogOpen(true);
  };

  const handleOpenDialogEdit = (row) => {
    setSelectedRow(row);
    setDialogOpenEdit(true);
  };

  const handleRegistrarPago = async () => {
    setEnviandoAlert(true);
    setEnviando(true);
    if (!montoPagado || montoPagado <= 0) {
      setAlertMessage("Debes ingresar un monto válido");
      setErrorAlertOpen(true);
      return;
    }

    try {
      await RegistrarPagoDeudor(
  selectedRow.id,
  Number(montoPagado),
  fechaPago || null,
  Number(sesionesPagadas || 0),
  Number(episodios || 0)
);

      setDialogOpen(false);
      setMontoPagado("");
      setSesionesPagadas("");
      setAlertMessage("Paciente registrado como pagado ✅");
      setSuccessAlertOpen(true);
      fetchGetDeudores(); // refresca tabla
      setDialogOpen(false);

    } catch (error) {
      setAlertMessage(error || "Error al registrar pagado ❌");
      setErrorAlertOpen(true);
      setMontoPagado("");
      setSesionesPagadas("");
      setEnviando(false);
    } finally {
      setEnviandoAlert(false);
      setEnviando(false);
    }
  };

  const handleEditPago = async () => {
    setEnviandoAlert(true);
    setEnviando(true);
    if (!NuevoMonto || NuevoMonto <= 0) {
      setAlertMessage("Debes ingresar un monto válido");
      setErrorAlertOpen(true);
      return;
    }

    try {
      await editarPacienteDeudor(selectedRow.id, {
        monto: Number(NuevoMonto),
        n_sesiones: Number(NuevasSesiones)
      });
      setDialogOpenEdit(false);
      setNuevoMonto("");
      setNuevasSesiones("");
      setAlertMessage("Paciente editado como pagado ✅");
      setSuccessAlertOpen(true);
      fetchGetDeudores(); // refresca tabla
      setDialogOpenEdit(false);

    } catch (error) {
  setAlertMessage(
    error?.response?.data?.message ||
    error?.message ||
    "Error al editar pagado ❌"
  );
  setErrorAlertOpen(true);
  setNuevasSesiones("");
  setNuevoMonto("");
  setEnviando(false);
} finally {
      setEnviandoAlert(false);
      setEnviando(false);
    }
  };




 




  const resumenPorMes = deudores.reduce((acc, d) => {
    // Intentamos obtener la fecha desde ingreso_paciente
    const fecha = d.ingreso_paciente?.fecha_pago || d.ingreso_paciente?.fecha_pago;

    // ❗ SOLO filtramos si no existe fecha
    if (!fecha) return acc;

    const [anio, mes] = fecha.split("-");
    const key = `${anio}-${mes}`;

    if (!acc[key]) acc[key] = [];
    acc[key].push(d);

    return acc;
  }, {});



  // Orden descendente
  const mesesOrdenados = Object.keys(resumenPorMes).sort(
    (a, b) => new Date(`${b}-01`) - new Date(`${a}-01`)
  );

  // Último mes registrado}// 🗓️ Convertimos "2025-11" en "Noviembre 2025"
  const formatearMes = (clave) => {
    if (!clave) return "";

    const [anio, mes] = clave.split("-");
    const nombresMeses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    // Convertimos el mes (que viene como string) a número y restamos 1 para el índice
    const nombreMes = nombresMeses[parseInt(mes, 10) - 1];

    // Capitalizamos y devolvemos
    return `${nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1)} ${anio}`;
  };

  const ultimoMes = mesesOrdenados[0];


  const ultimoMesFormateado = formatearMes(ultimoMes);



  const handleOpenEliminar = (egreso) => {
    setEgresoSeleccionado(egreso);
    setOpenEliminar(true);
  };

  const handleBuscarMesAnterior = () => {
  if (!mesSeleccionado || !anioSeleccionado) return;

  setMesConsulta(mesSeleccionado);
  setAnioConsulta(anioSeleccionado);

  setDialogMeses(false);
};


  const handleEliminarPago = async () => {
    setEnviandoAlert(true)
    try {
      await eliminarPagoDeudor(egresoSeleccionado.id);
      setOpenEliminar(false);
      setEgresoSeleccionado(null);
      setEnviandoAlert(false);
      setSuccessAlertOpen(true);
      setAlertMessage('Se ha eliminado correctamente el pago')
      fetchGetDeudores();
      handleCloseAbonoDialog();

    } catch (error) {
      setEnviandoAlert(false);
      setErrorAlertOpen(true);
      setAlertMessage("Error al eliminar pago:", error)
    }
  };



const resumenSucursalMesAnterior = deudoresReporteanterior?.por_sucursal || [];


 const estaCargando = loadingDeudores || loadingDeudoresReporte;
  const hayError = errorDeudores || errorDeudoresReporte;


  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 3,
          backgroundColor: "#fff",
          borderRadius: "16px",
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box display="flex" alignItems="center" gap={2} mb={6}>
          <img
            src={Logocolor}
            alt="Logo Clínica Activa"
            style={{ width: 55, height: 55, objectFit: "contain" }}
          />
          <Typography variant="h5" sx={TituloPrincipal}>
            Gestión de Pacientes Deudores
          </Typography>
        </Box>
        <Box sx={{
          display:"flex", alignItems:"center", justifyContent:'flex-end'
        }}>
          <Button
  variant="contained"
  color="success"
  sx={{fontFamily:'Poppins'}}
  startIcon={<BsFileEarmarkExcelFill />}
  onClick={handleDescargarExcel}
>
  Exportar Deudores
</Button>
        </Box>
        <Box display="flex" flexDirection='column' gap={2} mb={4}>
          {estaCargando ? (
        <Loading text="Cargando información deudores..." />
      ) : hayError ? (
        <Box textAlign="center" mt={5}>
          <Typography color="error" fontFamily="Poppins">
            Ocurrió un error al cargar la información
          </Typography>
        </Box>
      ) : (
        <>
            <Typography
                  variant="h6"
                  sx={{ mb: 2, textAlign: "center", fontWeight: "600", color: "#2c3e50", fontFamily: 'Poppins' }}
                >
                  Reporte financiero historico {reporteAnual?.anio_seleccionado}
                </Typography>
        <Box>
          <FormControl
  size="small"
  sx={{
    minWidth: 180,
    mb: 3,
  }}
>
  <InputLabel>Año</InputLabel>

  <Select
    value={anioSeleccionado || ""}
    label="Año"
    onChange={(e) => cambiarAnio(e.target.value)}
  >
    {reporteAnual?.anios_disponibles?.map((anio) => (
      <MenuItem key={anio} value={anio}>
        {anio}
      </MenuItem>
    ))}
  </Select>
</FormControl>
          <Grid container spacing={2}>

            {/* DEUDA */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Card sx={{ borderRadius: 3, boxShadow: "0px 4px 10px rgba(200,0,0,0.2)" }}>
                <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="h4" sx={{ fontFamily: 'Poppins', color: '#b71c1c' }}>
                      {reporteAnual?.resumen_general?.total_deuda?.cantidad ?? 0}
                    </Typography>
                    <Typography variant="h6" sx={{ fontFamily: 'Poppins', color: '#333' }}>
                      Total de Pacientes con <Box component="span" sx={{ color: '#b71c1c', fontWeight: 600 }}>No Pago</Box>
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666', fontFamily:'Poppins', fontWeight:'600' }}>
                      Monto total: ${formatCLP( reporteAnual?.resumen_general?.total_deuda?.monto ?? 0)}
                    </Typography>
                  </Box>
                  <BsExclamationTriangle size={50} color="#b71c1c" />
                </CardContent>
              </Card>
            </Grid>

            {/* PROCESO */}
              <Grid size={{ xs: 12, md: 4 }}>
              <Card sx={{ borderRadius: 3, boxShadow: "0px 4px 10px rgba(255,193,7,0.3)" }}>
                <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="h4" sx={{ fontFamily: 'Poppins', color: '#f96c25' }}>
                     {reporteAnual?.resumen_general?.total_deuda?.cantidad ?? 0}
                    </Typography>
                    <Typography variant="h6" sx={{ fontFamily: 'Poppins', color: '#333' }}>
                      Pacientes En <Box component="span" sx={{ color: '#f96c25', fontWeight: 600 }}>Deuda</Box>
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666', fontFamily:'Poppins', fontWeight:'600' }}>
                      Monto total: {formatCLP(reporteAnual?.resumen_general?.total_deuda?.monto ?? 0)}
                    </Typography>
                  </Box>
                  <BsHourglassSplit size={50} color="#f96c25" />
                </CardContent>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Card sx={{ borderRadius: 3, boxShadow: "0px 4px 10px rgba(255,193,7,0.3)" }}>
                <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="h4" sx={{ fontFamily: 'Poppins', color: '#f9a825' }}>
                     {reporteAnual?.resumen_general?.proceso?.cantidad ?? 0}
                    </Typography>
                    <Typography variant="h6" sx={{ fontFamily: 'Poppins', color: '#333' }}>
                      Pacientes En <Box component="span" sx={{ color: '#f9a825', fontWeight: 600 }}>Proceso</Box>
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666', fontFamily:'Poppins', fontWeight:'600' }}>
                      Monto total: {formatCLP(reporteAnual?.resumen_general?.proceso?.monto ?? 0)}
                    </Typography>
                  </Box>
                  <BsHourglassSplit size={50} color="#f9a825" />
                </CardContent>
              </Card>
            </Grid>



          </Grid>
</Box>

          <Box sx={{ mt: 4 }}>
            <Typography
              variant="h6"
              sx={{ mb: 2, textAlign: "center", fontWeight: "600", color: "#2c3e50", fontFamily: 'Poppins' }}
            >
              Resumen Financiero {ultimoMesFormateado || "Sin datos"}
            </Typography>

            <Grid container spacing={3}>
              {/* 🟠 CARD 1: DEUDA + PROCESO */}
              <Grid size={{ xs: 12, sm: 6 }}>
                <Card
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 3,
                    boxShadow: "0px 4px 10px rgba(42,103,69,0.3)",
                    p: 2,
                  }}
                >
                  <CardContent>
                    <Box display="flex" alignItems="center" gap={2}>
                      <BsCashStack size={50} color="#e67e22" />
                      <Box>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: "600",
                            color: "#2a8d74",
                            fontFamily: "Poppins",
                          }}
                        >
                          {formatCLP(deudoresReporte?.resumen_periodo?.total_monto)}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            color: "#555",
                            fontFamily: "Poppins",
                            mb: 1,
                          }}
                        >
                          Total deuda 
                        </Typography>

                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* 🟢 CARD 2: PAGADOS */}
              <Grid size={{ xs: 12, sm: 6 }}>
                <Card
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 3,
                    boxShadow: "0px 4px 10px rgba(42,103,69,0.3)",
                    p: 2,

                    alignItems: 'center',
                     display: 'flex'
                  }}
                >
                  <CardContent >
                    <Box display="flex" alignItems="center" gap={2}>
                      <BsCashStack size={50} color="#27ae60" />
                      <Box>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "#7f8c8d",
                            fontFamily: "Poppins",
                          }}
                        >
                          🟥 Saldo restante DEUDA:{" "}
                          <b>
                              {formatCLP(deudoresReporte?.resumen_periodo?.no_pago?.monto)}
                          </b>
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "#7f8c8d",
                            fontFamily: "Poppins",
                          }}
                        >
                          🟨 Saldo restante PROCESO:{" "}
                          <b>
                             {formatCLP(deudoresReporte?.resumen_periodo?.proceso?.monto)}
                          </b>
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

            </Grid>
            <Grid container spacing={3} mt={3}>
    {Object.entries(deudoresReporte?.resumen_periodo_por_sucursal ?? {}).map(
    ([sucursal, data]) => (

    <Grid key={sucursal} size={{ xs: 12, md: 4 }}>
      <Card sx={{ borderRadius: 3, p: 2 }}>
        <CardContent>
          <Typography variant="h5"  sx={{ mb: 2, textAlign: "center", fontWeight: "600", color: "#2c3e50", fontFamily: 'Poppins' }}>
            {sucursal}
          </Typography>

          <Typography variant="h6"  sx={{ mb: 2, textAlign: "center", fontWeight: "500", color: "#2c3e50", fontFamily: 'Poppins' }}>

            Pacientes: <b>{data.total_pacientes}</b>
          </Typography>

          <Typography variant="h6"  sx={{ mb: 2, textAlign: "center", fontWeight: "500", color: "#2c3e50", fontFamily: 'Poppins' }}>
            Monto:
            <b>
            
               {formatCLP(data.total_monto || "0")}
            </b>
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>
          </Box>
         
           </>
      )}
        </Box>
         <Box textAlign="center" mt={2} mb={3}>
            <Typography sx={{ fontFamily: "Poppins", color: "#2c3e50" }}>
              ¿Quieres ver otros reportes financieros de meses anteriores?{" "}
              <Box
                component="span"
                onClick={() => setDialogMeses(true)}
                sx={{
                  color: '#fff',
                  background: "#2a8d74",
                  fontWeight: "600",
                  cursor: "pointer",
                  padding: 2,
                  borderRadius: '50px'
                }}
              >
                Haz clic aquí
              </Box>
            </Typography>
          </Box>


          <Box sx={{ mt: 4 }}>
           {deudoresReporteanterior && (
              <Box mt={5}>
                <Typography
                  variant="h6"
                  sx={{ mb: 2, textAlign: "center", fontWeight: "600", color: "#2c3e50", fontFamily: 'Poppins' }}
                >
                  Reporte financiero de  {deudoresReporteanterior.periodo}
                </Typography>

                <Grid container spacing={3}>
                  {/* DEUDA */}
                  <Grid size={{ xs: 12, md: 3 }}>
                    <Card sx={{ borderRadius: 3, p: 3 }}>
                      <CardContent>

                        {/* TOTAL GENERAL ARRIBA */}
                        <Typography
                          variant="h3"
                          sx={{ color: "#182f53", fontFamily: "Poppins", fontWeight: 700 }}
                        >
                          {Number(deudoresReporteanterior.cantidad_estado_deuda) +
   Number(deudoresReporteanterior.cantidad_estado_proceso)}
                        </Typography>

                        <Typography sx={{ color: "#555", fontFamily: "Poppins", mb: 2 }}>
                          Total pacientes del mes (Deuda + Proceso)
                        </Typography>

                        <Divider sx={{ my: 2 }} />

                        {/* DETALLES ABAJO */}
                        <Grid container>

                          {/* PACIENTES DEUDORES */}
                          <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography
                              variant="h6"
                              sx={{ color: "#b71c1c", fontFamily: "Poppins", fontWeight: 600 }}
                            >
                               {deudoresReporteanterior.cantidad_estado_deuda}
                            </Typography>
                            <Typography sx={{ color: "#777", fontFamily: "Poppins" }}>
                              Pacientes Deudores
                            </Typography>
                          </Grid>

                          {/* PACIENTES PROCESO */}
                          <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography
                              variant="h6"
                              sx={{ color: "#f9a825", fontFamily: "Poppins", fontWeight: 600 }}
                            >
                                {deudoresReporteanterior.cantidad_estado_proceso}
                            </Typography>
                            <Typography sx={{ color: "#777", fontFamily: "Poppins" }}>
                              Pacientes en Proceso
                            </Typography>
                          </Grid>

                        </Grid>

                      </CardContent>
                    </Card>
                  </Grid>

                  {/* PROCESO */}
                  <Grid size={{ xs: 12, md: 3 }}>
                    <Card sx={{ borderRadius: 3, p: 2 }}>
                      <CardContent>
                        <Typography variant="h4" sx={{ color: "#f9a825", fontFamily: "Poppins" }}>
                          {formatCLP(deudoresReporteanterior.total_estado_proceso|| "0")}
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#585857", fontFamily: "Poppins" }}>Monto total pacientes en proceso</Typography>

                      </CardContent>
                    </Card>
                  </Grid>


                  <Grid size={{ xs: 12, md: 3 }}>
                    <Card sx={{ borderRadius: 3, p: 2 }}>
                      <CardContent>
                        <Typography variant="h4" sx={{ color: "#8c1515ff", fontFamily: "Poppins" }}>


                           {formatCLP(deudoresReporteanterior.total_estado_deuda)}

                        </Typography>
                        <Typography variant="body1" sx={{ color: "#585857", fontFamily: "Poppins" }} >Monto total  pacientes deudores </Typography>


                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid size={{ xs: 12, md: 3 }}>
                    <Card sx={{ borderRadius: 3, p: 2 }}>
                      <CardContent>
                        <Typography variant="h4" sx={{ color: "#182f53ff", fontFamily: "Poppins" }}>

 {formatCLP(deudoresReporteanterior.total_mes)}

                        </Typography>
 <Typography variant="body1" sx={{ color: "#585857", fontFamily: "Poppins" }} >Total  deuda del periodo </Typography> 


                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
 <Typography variant="h6"   sx={{ mb: 2, textAlign: "center", fontWeight: "600", color: "#2c3e50", fontFamily: 'Poppins' }}>
            Reporte financiero por sucursal
          </Typography>
                <Grid container spacing={3} mt={4} mb={5}>
 {resumenSucursalMesAnterior.map((sucursal) => (
    <Grid key={sucursal.id} size={{ xs: 12, md: 4 }}>
      <Card sx={{ borderRadius: 3, p: 2 }}>
        <CardContent>
          <Typography variant="h6"   sx={{ mb: 2, textAlign: "center", fontWeight: "600", color: "#2c3e50", fontFamily: 'Poppins' }}>
            {sucursal.sucursal}
          </Typography>

          <Typography   sx={{ mb: 2, textAlign: "center", fontWeight: "500", color: "#2c3e50", fontFamily: 'Poppins' }}>
           Pacientes: <b>{sucursal.cantidad_pacientes}</b>
          </Typography>

          <Typography   sx={{ mb: 2, textAlign: "center", fontWeight: "500", color: "#2c3e50", fontFamily: 'Poppins' }}>
           Monto:
            <b>
             {formatCLP(sucursal.total_deuda)}
            </b>
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>

              </Box>
            )}

          </Box>
        {/* Estado de carga */}
        {estaCargando ? (
           <Loading text="Cargando información financiera..." />
        ) : hayError ? (
          <Alert severity="error">
            Error al cargar los deudores: {errorDeudores}
          </Alert>
        ) : deudores.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: 1,
              color: "#666",
              textAlign: "center",
            }}
          >
            <SentimentSatisfiedAltIcon sx={{ fontSize: 60, mb: 1 }} />
            <Typography variant="h6" sx={{ fontFamily: "Poppins" }}>
              ¡Actualmente no hay deudores registrados! 😊
            </Typography>
          </Box>
        ) : (
          <Box sx={{ position: 'relative' }}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "flex-start",
                mb: 2,
                position: 'absolute',
                zIndex: 1
              }}
            >

              <Autocomplete
                freeSolo
                options={opcionesUnicas.map((f) => `${f.nombre_paciente} (${f.rut})`)}
                onInputChange={(e, value) => setBusqueda(value)}
                sx={{
                  width: 350,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "30px",
                    fontFamily: "Poppins",
                    "& fieldset": {
                      borderColor: "#C5C5C5",
                    },
                    "&:hover fieldset": {
                      borderColor: "#4C96AF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#4C96AF",
                      boxShadow: "0 0 0 2px rgba(76, 150, 175, 0.2)",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    fontFamily: "Poppins",
                    fontWeight: 500,
                  },
                  "& .MuiAutocomplete-option": {
                    fontFamily: "Poppins",
                  },
                }}
                renderOption={(props, option) => {
                  const [nombre, rutPart] = option.split(" (");
                  const rut = rutPart?.replace(")", "") || "";

                  return (
                    <Box
                      component="li"
                      {...props}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        fontFamily: "Poppins",
                        p: 1.2,
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: "#f0f8fa",
                        },
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          color: "#333",
                          fontSize: 14,
                          textTransform: "capitalize",
                        }}
                      >
                        {nombre}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#777",
                          fontSize: 13,
                        }}
                      >
                        {rut}
                      </Typography>
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Buscar por nombre o RUT"
                    variant="outlined"
                    InputLabelProps={{ style: { fontFamily: "Poppins" } }}
                    inputProps={{
                      ...params.inputProps,
                      style: {
                        fontFamily: "Poppins",
                        fontSize: 14,
                      },
                    }}
                  />
                )}
              />
              <FormControl sx={{ ...InputBuscador, width: 220 }}>
  <InputLabel>Sucursal</InputLabel>
  <Select
    value={sucursalFiltro}
    label="Sucursal"
    onChange={(e) => setSucursalFiltro(e.target.value)}
  >
    <MenuItem value="">Todas</MenuItem>
    {[...new Set(filas.map(f => f.sucursal))]
      .filter(Boolean)
      .map((suc) => (
        <MenuItem key={suc} value={suc}>
          {suc}
        </MenuItem>
      ))}
  </Select>
</FormControl>

              {/* 🔹 Filtro por estado */}
              <FormControl sx={{ ...InputBuscador, width: 200 }}>
                <InputLabel sx={{ fontFamily: "Poppins" }}>Filtrar por Estado</InputLabel>
                <Select
                  value={estadoFiltro}
                  label="Filtrar por Estado"
                  onChange={(e) => setEstadoFiltro(e.target.value)}
                  sx={{ fontFamily: "Poppins" }}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="DEUDA">Deuda</MenuItem>
                  <MenuItem value="PROCESO">Proceso</MenuItem>

                </Select>
              </FormControl>
              
              {/* 🔹 Filtro por Mes */}
<FormControl sx={{ ...InputBuscador, width: 150 }}>
  <InputLabel sx={{ fontFamily: "Poppins" }}>Mes</InputLabel>
  <Select
    value={mesFiltro}
    label="Mes"
    onChange={(e) => setMesFiltro(e.target.value)}
    sx={{ fontFamily: "Poppins" }}
  >
    <MenuItem value="">Todos</MenuItem>
    <MenuItem value="01">Enero</MenuItem>
    <MenuItem value="02">Febrero</MenuItem>
    <MenuItem value="03">Marzo</MenuItem>
    <MenuItem value="04">Abril</MenuItem>
    <MenuItem value="05">Mayo</MenuItem>
    <MenuItem value="06">Junio</MenuItem>
    <MenuItem value="07">Julio</MenuItem>
    <MenuItem value="08">Agosto</MenuItem>
    <MenuItem value="09">Septiembre</MenuItem>
    <MenuItem value="10">Octubre</MenuItem>
    <MenuItem value="11">Noviembre</MenuItem>
    <MenuItem value="12">Diciembre</MenuItem>
  </Select>
</FormControl>

{/* 🔹 Filtro por Año */}
<FormControl sx={{ ...InputBuscador, width: 150 }}>
  <InputLabel sx={{ fontFamily: "Poppins" }}>Año</InputLabel>
  <Select
    value={anioFiltro}
    label="Año"
    onChange={(e) => setAnioFiltro(e.target.value)}
    sx={{ fontFamily: "Poppins" }}
  >
    <MenuItem value="">Todos</MenuItem>

    {/* AÑOS DINÁMICOS SEGÚN LOS REGISTROS */}
    {[...new Set(filas.map(f => f.fecha?.split("-")[0]))]
      .filter(Boolean)
      .sort()
      .map(a => <MenuItem key={a} value={a}>{a}</MenuItem>)}
  </Select>
</FormControl>

            </Box>

            <Box sx={{ flexGrow: 1 }}>
              <DataGrid
                rows={filasFiltradas}
                showToolbar
                columns={columns}
                pageSize={5}
                pageSizeOptions={[5, 10, 25, 50]}
                disableSelectionOnClick
                autoHeight
                rowHeight={120}
                initialState={{
                  pagination: { paginationModel: { pageSize: 10, page: 0 } },
                }}
                slots={{ noRowsOverlay: DiseñoDataGrid }}
                getRowId={(row) => row.id}
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  '& .MuiDataGrid-columnHeaders': {
                    color: '#113e21ff',
                    fontWeight: 600,
                    textTransform: 'capitalize',
                  },
                  '& .MuiDataGrid-cell': {
                    textTransform: 'capitalize',
                  },
                }}
              />
            </Box>
          </Box>
        )}
      </Paper>
      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert}>
        <Box sx={modalStyle}>
          <section style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress style={{ color: "#2a8d74" }} />
            <p className="alert-text">Procesando solicitud...</p>
          </section>
        </Box>
      </Modal>




      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="md"  >
        <DialogTitle sx={TituloColor}>
          Registrar Pago
        </DialogTitle>
        <DialogContent>
          <Typography sx={Titulo}>
            Paciente: <strong> {selectedRow?.nombre_paciente}</strong>
          </Typography>
          <Box sx={{
            display: 'flex', alignItems: 'center'
            , justifyContent: 'space-around',
            mt: 2, mb: 4
          }}>
            <Card sx={{
              m: 1,
              flex: 1,
              backgroundColor: "#ffffff", // blanco limpio
              borderRadius: 3,            // bordes redondeados
              boxShadow: "0px 4px 10px rgba(197, 80, 13, 0.4)", // sombreado sutil
              transition: "transform 0.2s, box-shadow 0.2s",

            }}>
              <CardContent>
                <Typography sx={{
                  color: "#074b50ff",
                  fontFamily: "Poppins",
                  fontWeight: 500
                }}>Total Deuda</Typography>
                <Typography sx={{
                  color: "#7f8c8d",
                  fontFamily: "Poppins",
                }}>  {new Intl.NumberFormat("es-CL", {
                  style: "currency",
                  currency: "CLP",
                }).format(selectedRow?.total_deuda)}</Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                m: 1,
                flex: 1,
                backgroundColor: "#ffffff", // blanco limpio
                borderRadius: 3,            // bordes redondeados
                boxShadow: "0px 4px 10px rgba(187, 185, 64, 0.67)", // sombreado sutil
                transition: "transform 0.2s, box-shadow 0.2s",

              }}>
              <CardContent>
                <Typography sx={{
                  color: "#074b50ff",
                  fontFamily: "Poppins",
                  fontWeight: 500
                }}>Saldo</Typography>
                <Typography sx={{
                  color: "#7f8c8d",
                  fontFamily: "Poppins",
                }}> {new Intl.NumberFormat("es-CL", {
                  style: "currency",
                  currency: "CLP",
                }).format(selectedRow?.saldo_restante)} </Typography>
              </CardContent>
            </Card>
          </Box>
          <TextField
  fullWidth
  label="Fecha de pago"
  type="date"
  value={fechaPago}
  onChange={(e) => setFechaPago(e.target.value)}
  InputLabelProps={{ shrink: true }}
  sx={{ ...Input, mb: 2, mt: 2 }}
/>

          <TextField
            fullWidth
            label="Monto pagado"
            type="number"
            value={montoPagado}
            onChange={(e) => setMontoPagado(e.target.value)}
            sx={{ ...Input, mb: 2, mt: 2 }}
          />

          <TextField
            fullWidth
            label="Sesiones pagadas"
            type="number"
            value={sesionesPagadas}
            onChange={(e) => setSesionesPagadas(e.target.value)}
            sx={{ ...Input, mb: 2, mt: 2 }}
          />

          <TextField
            fullWidth
            label="episodios"
            type="number"
            value={episodios}
            onChange={(e) => setEpisodios(e.target.value)}
            sx={{ ...Input, mb: 2, mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} sx={buttonCancelar}>Cancelar</Button>
          <Button
            variant="contained"
            disabled={enviando}
            onClick={handleRegistrarPago}
            sx={buttonGuardar}
          >
            {enviando ? "Registrando..." : "Registrar"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={dialogOpenEdit} onClose={() => setDialogOpenEdit(false)} fullWidth maxWidth="md"  >
        <DialogTitle sx={TituloColor}>
          Registrar Monto paciente
        </DialogTitle>
        <DialogContent>
          <Typography sx={Titulo}>
            Paciente: <strong> {selectedRow?.nombre_paciente}</strong>
          </Typography>
          <Box sx={{
            display: 'flex', alignItems: 'center'
            , justifyContent: 'space-around',
            mt: 2, mb: 4
          }}>


          </Box>
          <TextField
            fullWidth
            label="Monto"
            type="number"
            value={NuevoMonto}
            onChange={(e) => setNuevoMonto(e.target.value)}
            sx={{ ...Input, mb: 2, mt: 2 }}
          />
          <TextField
            fullWidth
            label="Sesiones contratadas"
            type="number"
            value={NuevasSesiones}
            onChange={(e) => setNuevasSesiones(e.target.value)}
            sx={{ ...Input, mb: 2, mt: 2 }}
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpenEdit(false)} sx={buttonCancelar}>Cancelar</Button>
          <Button
            variant="contained"
            disabled={enviando}
            onClick={handleEditPago}
            sx={buttonGuardar}
          >
            {enviando ? "Registrando..." : "Registrar"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={abonoDialogOpen}
        onClose={handleCloseAbonoDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            fontFamily: "Poppins",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            gap: 1,
            backgroundColor: "#4c96afff",
            color: "#fff",
          }}
        >
          <MonetizationOnIcon />
          Historial de Abonos
        </DialogTitle>

        <DialogContent>
          <Typography
            sx={{ mt: 2, mb: 2, fontFamily: "Poppins", fontWeight: 500 }}
          >
            Paciente:{" "}
            <strong>{selectedRow?.nombre_paciente || "No seleccionado"}</strong>
          </Typography>

          {abonosRows.length > 0 ? (
            <Box sx={{ height: 400, width: "100%" }}>
              <DataGrid
                rows={abonosRows}
                columns={abonoColumns}
                pageSize={5}
                disableRowSelectionOnClick
                slots={{ noRowsOverlay: DiseñoDataGrid }}
                getRowId={(row) => row.id}
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  '& .MuiDataGrid-columnHeaders': {
                    color: '#113e21ff',
                    fontWeight: 600,
                    textTransform: 'capitalize',
                  },
                  '& .MuiDataGrid-cell': {
                    textTransform: 'capitalize',
                  },
                }}
              />
            </Box>
          ) : (
            <Typography
              variant="body2"
              sx={{ textAlign: "center", mt: 4, fontFamily: "Poppins" }}
            >
              No existen abonos registrados para este paciente.
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleCloseAbonoDialog}
            variant="contained"
            sx={{
              textTransform: "capitalize",
              fontFamily: "Poppins",
              backgroundColor: "#4c96afff",
              "&:hover": { backgroundColor: "#3b7d94" },
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dialogMeses} onClose={() => setDialogMeses(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontFamily: "Poppins", fontWeight: 600 }}>
          Seleccionar Mes y Año
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                select
                fullWidth
                label="Mes"
                sx={{ ...InputBuscador, width: 200 }}
                value={mesSeleccionado}
                onChange={(e) => setMesSeleccionado(e.target.value)}
              >
                {[
                  { num: "01", label: "Enero" },
                  { num: "02", label: "Febrero" },
                  { num: "03", label: "Marzo" },
                  { num: "04", label: "Abril" },
                  { num: "05", label: "Mayo" },
                  { num: "06", label: "Junio" },
                  { num: "07", label: "Julio" },
                  { num: "08", label: "Agosto" },
                  { num: "09", label: "Septiembre" },
                  { num: "10", label: "Octubre" },
                  { num: "11", label: "Noviembre" },
                  { num: "12", label: "Diciembre" },
                ].map((m) => (
                  <MenuItem key={m.num} value={m.num}>
                    {m.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={6}>
              <TextField
                sx={{ ...InputBuscador, width: 200 }}
                label="Año"
                select
                fullWidth
                value={anioSeleccionado}
                onChange={(e) => setAnioSeleccionado(e.target.value)}
              >
                {[
                  { num: "2025", label: "2025" },
                   { num: "2026", label: "2026" }

                ].map((m) => (
                  <MenuItem key={m.num} value={m.num}>
                    {m.label}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setDialogMeses(false)}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={() => handleBuscarMesAnterior()}
            sx={{ backgroundColor: "#2a8d74" }}
          >
            Buscar
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog open={openEliminar} onClose={() => setOpenEliminar(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={TituloPrincipal}>Confirmar eliminación</DialogTitle>
        <DialogContent dividers>
          <Typography sx={Texto}>¿Estás seguro que deseas eliminar este pago?</Typography>
          <Typography fontWeight={500} sx={Texto} mt={1}>{egresoSeleccionado?.monto_pagado}</Typography>
        </DialogContent>
        <DialogActions>
          <Button sx={buttonCancelar} onClick={() => setOpenEliminar(false)}>Cancelar</Button>
          <Button sx={buttonGuardar} onClick={handleEliminarPago}>Eliminar</Button>
        </DialogActions>
      </Dialog>

    </Container>
  );
};
